// import { Box, Button, Modal, TextField, Typography } from "@material-ui/core";
// import React, { useState } from "react";
// import useStyles from "./EmailInputModal.style";

// const EmailInputModal = ({ open, handleClose, handleSave }) => {
//   const [email, setEmail] = useState("");
//   const classes = useStyles();

//   const handleSubmit = () => {
//     if (email.trim() !== "") {
//       handleSave(email);
//       //   handleClose();
//     }
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={handleClose}
//       aria-labelledby="email-modal-title"
//     >
//       <Box className={classes.root}>
//         <Typography
//           id="email-modal-title"
//           variant="h6"
//           mb={2}
//           className={classes.title}
//         >
//           Enter Your Email
//         </Typography>
//         {/* <TextField
//           fullWidth
//           label="Email Address"
//           variant="outlined"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         /> */}
//         <TextField
//           fullWidth
//           className={classes.couponInput}
//           label="Email Address"
//           variant="outlined"
//           value={email}
//           InputLabelProps={{
//             classes: {
//               root: classes.label,
//             },
//             shrink: true,
//           }}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <Box mt={2} display="flex" justifyContent="flex-end">
//           <Button
//             onClick={handleClose}
//             sx={{ mr: 1 }}
//             className={classes.cancelBtn}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             className={classes.saveBtn}
//             onClick={handleSubmit}
//           >
//             Save
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default EmailInputModal;

import { Box, Button, Modal, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "./EmailInputModal.style";

const EmailInputModal = ({ open, handleClose, handleSave }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const classes = useStyles();

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleSubmit = () => {
    if (email.trim() === "") {
      setError("Email is required.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError("");
    handleSave(email);
    // handleClose(); // You can decide whether to close the modal after saving
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (value === "") {
      setError("Email is required.");
    } else if (!validateEmail(value)) {
      setError("Please enter a valid email address.");
    } else {
      setError("");
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="email-modal-title"
    >
      <Box className={classes.root}>
        <Typography
          id="email-modal-title"
          variant="h6"
          mb={2}
          className={classes.title}
        >
          Enter Your Email
        </Typography>

        <TextField
          fullWidth
          className={classes.couponInput}
          label="Email Address"
          variant="outlined"
          value={email}
          error={Boolean(error)}
          helperText={error}
          InputLabelProps={{
            classes: {
              root: classes.label,
            },
            shrink: true,
          }}
          onChange={handleChange}
        />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            onClick={handleClose}
            sx={{ mr: 1 }}
            className={classes.cancelBtn}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={classes.saveBtn}
            onClick={handleSubmit}
            disabled={Boolean(error) || email.trim() === ""}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EmailInputModal;
